import { createFileRoute } from "@tanstack/react-router";

import ChallengeOverview from "@/components/ChallengeOverview/ChallengeOverview";

const Component = () => {
  const challengeUuid = Route.useParams().challengeUuid;
  return <ChallengeOverview challengeUuid={challengeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid")({
  component: Component,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/challenges",
      },
    };
  },
});
